<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <b-link class="navbar-brand" to="#">
        <!-- src="../assets/imgs/logo-carcool.png" -->
        <!-- <img
          class="navbar-brand-full"
          src="../assets/imgs/demo.png"
          width="120"
          height="45"
          alt="Demo"
        > -->

        <img
          class="navbar-brand-full"
          :src="getImgUrl(logo)"
          width="120"
          alt="Demo"
        >

      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg"/>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <div v-if="user.role.code === constants.SOLICITANTE">
        <AsideToggler class="d-none d-lg-block"/>
        <AsideToggler class="d-lg-none" mobile/>
      </div>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <button
          class="btn btn-primary"
          @click="reassign()"
          v-if="user.role.code == constants.PLANIFICADOR"
        >REASIGNAR</button>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        Carcool - Software de gestión logística y transporte
        <!-- <span class="ml-1">&copy; 2017 creativeLabs.</span> -->
      </div>
      <div class="ml-auto">
        <!-- <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>-->
      </div>
    </TheFooter>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "../constants";
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import api from "@/helpers/api";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      constants: constants,
      environment: process.env.VUE_APP_ENVIRONMENT,
      logo: process.env.VUE_APP_LOGO
    };
  },
  mounted() {
    console.log(this.environment);
  },
  computed: {
    ...mapGetters({ user: "user/user" }),
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  methods: {
    getImgUrl(logo){
      return require('../assets/imgs/'+logo)
      // var images = require.context('../img/assets/', false, /\.png$/)
      // return images('./' + logo)
    },
    reassign() {
      if (
        confirm(
          "Este proceso reasignará toda la programación de mañana, ¿Está seguro?"
        )
      ) {
        console.log("ENTRA");
        api.get("reassign_inland").then(response => {
          console.log(response);
          this.$toastr.success("Proceso finalizado.", "Reasignación", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        });
      }
    }
  }
};
</script>
